import AppController from 'app/backbone/lib/controllers/app_controller';
import EmptyView from './view';

export default class Controller extends AppController {
  showPageView() {
    return this.show(new EmptyView);
  }
}